export function roundNumber(value: number | undefined, maxDecimals: number) {
	return value && Math.round(value * Math.pow(10, maxDecimals)) / Math.pow(10, maxDecimals);
}
